import { IOfferSpendByAccountListTableLang } from '../../../types/lang'

export const offerSpendByAccountListTableLang: IOfferSpendByAccountListTableLang = {
	offer_spend_by_account_list_table: {
		column_account_id: 'Account ID',
		column_account: 'Account',
		column_account_in_group: 'Account in Group',
		column_kt_group: 'KT Group',
		column_amount: 'Amount',
		column_date: 'Date',
	}
}